import { render, staticRenderFns } from "./travel-policy-detail-info.vue?vue&type=template&id=5aa66282&scoped=true&"
import script from "./travel-policy-detail-info.vue?vue&type=script&lang=js&"
export * from "./travel-policy-detail-info.vue?vue&type=script&lang=js&"
import style0 from "./travel-policy-detail-info.vue?vue&type=style&index=0&id=5aa66282&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa66282",
  null
  
)

export default component.exports